export const applyMacroMode = async (canvas, ctx, setMessage, language) => {
  // 진행 상황 업데이트
  setMessage(language === 'KR' ? '접사 모드 적용 중 (1/3) - 디테일 강화...' : 'Applying Macro Mode (1/3) - Enhancing details...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // 접사 모드 효과 적용
  // 1. 날카로운 디테일 증가
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 엣지 검출 및 디테일 강화
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        const current = tempData[pos + c];
        const top = tempData[pos - canvas.width * 4 + c];
        const bottom = tempData[pos + canvas.width * 4 + c];
        const left = tempData[pos - 4 + c];
        const right = tempData[pos + 4 + c];
        
        // 디테일 강화를 위한 언샵 마스킹
        data[pos + c] = Math.min(255, Math.max(0, 
          current * 2.2 - (top + bottom + left + right) / 5));
      }
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 색 보정
  setMessage(language === 'KR' ? '접사 모드 적용 중 (2/3) - 색상 강화...' : 'Applying Macro Mode (2/3) - Enhancing colors...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const colorData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const colorPixels = colorData.data;
  
  // 채도 및 선명도 증가
  for (let i = 0; i < colorPixels.length; i += 4) {
    // 채도 증가
    const avg = (colorPixels[i] + colorPixels[i + 1] + colorPixels[i + 2]) / 3;
    colorPixels[i] = Math.min(255, avg + (colorPixels[i] - avg) * 1.3);
    colorPixels[i + 1] = Math.min(255, avg + (colorPixels[i + 1] - avg) * 1.3);
    colorPixels[i + 2] = Math.min(255, avg + (colorPixels[i + 2] - avg) * 1.3);
  }
  
  ctx.putImageData(colorData, 0, 0);
  
  // 3. 주변부 약간 어둡게 (비네팅)
  setMessage(language === 'KR' ? '접사 모드 적용 중 (3/3) - 주변부 효과 적용...' : 'Applying Macro Mode (3/3) - Adding vignette...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const vignetteData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const vignettePixels = vignetteData.data;
  
  const centerX = canvas.width / 2;
  const centerY = canvas.height / 2;
  const maxDistance = Math.sqrt(centerX * centerX + centerY * centerY);
  
  for (let y = 0; y < canvas.height; y++) {
    for (let x = 0; x < canvas.width; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      // 중심에서 현재 픽셀까지의 거리 계산
      const dx = x - centerX;
      const dy = y - centerY;
      const distance = Math.sqrt(dx * dx + dy * dy);
      
      // 거리에 따른 비네팅 강도 계산
      const strength = 0.75 + 0.25 * Math.min(1, Math.max(0, 1 - distance / maxDistance));
      
      // 픽셀 값 조정
      for (let c = 0; c < 3; c++) {
        vignettePixels[pos + c] = Math.min(255, Math.max(0, vignettePixels[pos + c] * strength));
      }
    }
  }
  
  ctx.putImageData(vignetteData, 0, 0);
  
  // 처리 완료
  setMessage(language === 'KR' ? '접사 모드 적용 완료!' : 'Macro Mode applied!');
};